import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import accountSettingsEn from '@/locales/en/accountSettings.json';
import bookingsServicesEn from '@/locales/en/bookingsServices.json';
import checkoutEn from '@/locales/en/checkout.json';
import commonEn from '@/locales/en/common.json';
import customersEn from '@/locales/en/customers.json';
import dataGridEn from '@/locales/en/dataGrid.json';
import formsEn from '@/locales/en/forms.json';
import fulfilmentProvidersEn from '@/locales/en/fulfilmentProviders.json';
import inventoryEn from '@/locales/en/inventory.json';
import loginEn from '@/locales/en/login.json';
import notesEn from '@/locales/en/notes.json';
import ordersEn from '@/locales/en/orders.json';
import paymentProcessorsEn from '@/locales/en/paymentProcessors.json';
import paymentsEn from '@/locales/en/payments.json';
import productsEn from '@/locales/en/products.json';
import shippingEn from '@/locales/en/shipping.json';
import userSettingsEn from '@/locales/en/userSettings.json';
import usersManagementEn from '@/locales/en/usersManagement.json';
import commonFr from '@/locales/fr/common.json';
import customersFr from '@/locales/fr/customers.json';
import dataGridFr from '@/locales/fr/dataGrid.json';
import ordersFr from '@/locales/fr/orders.json';

const resources = {
  en: {
    common: commonEn,
    orders: ordersEn,
    dataGrid: dataGridEn,
    customers: customersEn,
    products: productsEn,
    inventory: inventoryEn,
    login: loginEn,
    accountSettings: accountSettingsEn,
    fulfilmentProviders: fulfilmentProvidersEn,
    userSettings: userSettingsEn,
    bookingsServices: bookingsServicesEn,
    usersManagement: usersManagementEn,
    paymentProcessors: paymentProcessorsEn,
    payments: paymentsEn,
    notes: notesEn,
    forms: formsEn,
    checkout: checkoutEn,
    shipping: shippingEn,
  },
  fr: {
    common: commonFr,
    orders: ordersFr,
    dataGrid: dataGridFr,
    customers: customersFr,
  },
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    debug: false,
    interpolation: {
      escapeValue: false,
    },
    react: {
      useSuspense: false,
    },
  })
  .catch((error) => {
    console.error('i18n error:', error);
  });

export default i18n;
